import { render, staticRenderFns } from "./ResumoNascimentoDetalhes.vue?vue&type=template&id=0dcad575&"
import script from "./ResumoNascimentoDetalhes.vue?vue&type=script&lang=js&"
export * from "./ResumoNascimentoDetalhes.vue?vue&type=script&lang=js&"
import style0 from "./ResumoNascimentoDetalhes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports